import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

/**
 * HU014 - Rotas das telas de Certificados Externos, uma por perfil:
 *  - Médico Participante  → /certificados-externos
 *  - Técnico MS (CGAPP)   → /administracao/certificados-externos
 *  - Gestores             → /consulta-certificados
 */
export const certificadosExternosRoutes: Routes = [
  {
    path: 'certificados-externos',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Certificados Externos',
      breadcrumb: [{ label: 'Formação' }, { label: 'Certificados Externos' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./certificados-externos-medico/certificados-externos-medico.component').then(
            (m) => m.CertificadosExternosMedicoComponent
          ),
        data: {
          title: 'Certificados Externos',
          roles: [Role.CERTIFICADO_EXTERNO_ADICIONAR_PROFISSIONAL, Role.CERTIFICADO_EXTERNO_VISUALIZAR_PROFISSIONAL],
          breadcrumb: [
            { label: 'Formação' },
            { label: 'Certificados Externos', url: '/certificados-externos' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./certificados-externos-visualizar/certificados-externos-visualizar.component').then(
            (m) => m.CertificadosExternosVisualizarComponent
          ),
        data: {
          title: 'Visualizar Certificado',
          roles: [Role.CERTIFICADO_EXTERNO_VISUALIZAR_PROFISSIONAL],
          voltarUrl: '/certificados-externos',
          breadcrumb: [
            { label: 'Formação' },
            { label: 'Certificados Externos', url: '/certificados-externos' },
            { label: 'Visualizar', url: '/certificados-externos/visualizar' },
          ],
        },
      },
    ],
  },
  {
    path: 'administracao/certificados-externos',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Certificados Externos',
      breadcrumb: [{ label: 'Administração' }, { label: 'Certificados Externos' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./certificados-externos-tecnico/certificados-externos-tecnico.component').then(
            (m) => m.CertificadosExternosTecnicoComponent
          ),
        data: {
          title: 'Certificados Externos',
          roles: [Role.CERTIFICADO_EXTERNO_VISUALIZAR_ADMINISTRACAO],
          breadcrumb: [
            { label: 'Administração' },
            { label: 'Certificados Externos', url: '/administracao/certificados-externos' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./certificados-externos-visualizar/certificados-externos-visualizar.component').then(
            (m) => m.CertificadosExternosVisualizarComponent
          ),
        data: {
          title: 'Visualizar Certificado',
          roles: [Role.CERTIFICADO_EXTERNO_VISUALIZAR_ADMINISTRACAO],
          voltarUrl: '/administracao/certificados-externos',
          breadcrumb: [
            { label: 'Administração' },
            { label: 'Certificados Externos', url: '/administracao/certificados-externos' },
            { label: 'Visualizar', url: '/administracao/certificados-externos/visualizar' },
          ],
        },
      },
    ],
  },
  {
    path: 'consulta-certificados',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Consulta de Certificados',
      breadcrumb: [{ label: 'Formação' }, { label: 'Consulta de Certificados' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./certificados-externos-gestor/certificados-externos-gestor.component').then(
            (m) => m.CertificadosExternosGestorComponent
          ),
        data: {
          title: 'Consulta de Certificados',
          roles: [Role.CERTIFICADO_EXTERNO_VISUALIZAR_ADMINISTRACAO],
          breadcrumb: [
            { label: 'Formação' },
            { label: 'Consulta de Certificados', url: '/consulta-certificados' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./certificados-externos-visualizar/certificados-externos-visualizar.component').then(
            (m) => m.CertificadosExternosVisualizarComponent
          ),
        data: {
          title: 'Visualizar Certificado',
          roles: [Role.CERTIFICADO_EXTERNO_VISUALIZAR_ADMINISTRACAO],
          voltarUrl: '/consulta-certificados',
          breadcrumb: [
            { label: 'Formação' },
            { label: 'Consulta de Certificados', url: '/consulta-certificados' },
            { label: 'Visualizar', url: '/consulta-certificados/visualizar' },
          ],
        },
      },
    ],
  },
];
